export const Trust_We_Won_Stats = [
    {
        value: 99,
        suffix: "%",
        prefix: "",
        labelLines: "DELIVERY ON-TIME OPERATIONAL EFFICIENCY"
    },
    {
        value: 10,
        suffix: "M+",
        prefix: "$",
        labelLines: "CLIENT BUSINESS MANAGED VIA OUR SOFTWARES"
    },
    {
        value: 95,
        suffix: "%",
        prefix: "",
        labelLines: "REPEAT CLIENTS LONG-TERM PROJECTS"
    }
]; 